import React from "react";

import LeftSide from "./components/LeftSide";
import RightSide from "./components/RightSide";

import classes from "./index.module.css";

const Events = () => {
  return (
    <div className={classes["wrapper"]}>
      <LeftSide />
      <RightSide />
    </div>
  );
};

export default Events;
